import { Injectable, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CmsFeatureFlags } from '@models/cms/app.model';
import {
  FeatureFlagsCmsOverridable,
  FeatureFlags,
  FeatureFlagsEnum,
} from '@models/environment.type';
import { User } from '@models/user.model';
import { Store } from '@ngrx/store';
import { selectLoggedInUser } from '@selectors/user.selector';
import { EnvironmentService } from 'src/app/services/environment-service/environment.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private loggedInUser = toSignal<User | null>(this.store.select(selectLoggedInUser));
  static _config: FeatureFlags = {
    [FeatureFlagsEnum.CHECK_IN]: '',
    [FeatureFlagsEnum.MODIFY_ALA_CARTE]: '',
    [FeatureFlagsEnum.FLIFO]: '',
    [FeatureFlagsEnum.USER_PROFILE]: '',
    [FeatureFlagsEnum.FORGOT_PASSWORD]: '',
    [FeatureFlagsEnum.EVERYMUNDO]: '',
    [FeatureFlagsEnum.CONNECTIONS]: '',
    [FeatureFlagsEnum.CAR_TRAWLER]: '',
    [FeatureFlagsEnum.CREDIT_FILE_ENABLED]: '',
    [FeatureFlagsEnum.BUNDLE_RESTRICTION]: '',
    [FeatureFlagsEnum.SELF_SERVICE_UPGRADE]: '',
    [FeatureFlagsEnum.SAVE_TO_WALLET_APPLE]: '',
    [FeatureFlagsEnum.SAVE_TO_WALLET_GOOGLE]: '',
    [FeatureFlagsEnum.LOW_FARE_CALENDAR]: '',
    [FeatureFlagsEnum.LOG_IN]: '',
    [FeatureFlagsEnum.GEO_HOME_BANNERS]: '',
    [FeatureFlagsEnum.PLUSGRADE]: '',
    [FeatureFlagsEnum.INSURANCE_COUNTRY]: '',
    [FeatureFlagsEnum.HOME_FEATURED_IN]: '',
    [FeatureFlagsEnum.HOME_NEW_MAIN_CARD]: '',
    [FeatureFlagsEnum.CHAT_BOT]: '',
    [FeatureFlagsEnum.APPLE_PAY]: '',
    [FeatureFlagsEnum.CHANGE_VALIDATION]: '',
    [FeatureFlagsEnum.SHOW_PREMIUM_LIGHT]: '',
    [FeatureFlagsEnum.PROMO_INPUT_OPEN]: '',
    [FeatureFlagsEnum.KTN]: '',
    [FeatureFlagsEnum.DISRUPTION_CHECK]: '',
    [FeatureFlagsEnum.ALLOW_MACS]: '',
    [FeatureFlagsEnum.BRAVO_CONTENT]: '',
    [FeatureFlagsEnum.MRZ_OCR_POC]: ''
  };

  private get config(): FeatureFlags {
    return FeatureFlagService._config;
  }

  constructor(private store: Store) {}

  static loadConfig(): Promise<void> {
    return new Promise((resolve) => {
      FeatureFlagService._config = EnvironmentService.environment.featureFlags;

      resolve();
    });
  }

  static useCmsConfigs(featureFlags: CmsFeatureFlags): Promise<void> {
    return new Promise((resolve) => {
      if (EnvironmentService.environment.allowCmsOverride) {
        FeatureFlagsCmsOverridable.forEach((flag) => {
          FeatureFlagService._config[flag] = FeatureFlagService._config[flag]
            ? featureFlags[flag]
            : FeatureFlagService._config[flag];
        });
      }

      resolve();
    });
  }

  /**
   * Gets the content for the given CMS key
   * as a JavaScript object.
   *
   * @param feature The Feature Flag key
   * @returns boolean value of feature requested
   */
  isFeatureActive = (feature: FeatureFlagsEnum): boolean =>
    !!this.config[feature];

  /**
   * True if user is from LUX Interactive
   */
  isLuxUser = computed(
    () =>
      !!this.loggedInUser()
        ?.emailAddresses.find((a) => a.type === 'P')
        ?.email.endsWith('@luxinteractive.com'),
  );
}
